import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { ApiAuthService, AuthService } from '@shared';
import { firstValueFrom } from 'rxjs';

const POS_ALLOWED_ROLES = new Set(['pos']);

export const posRedirectIfAuthenticated: CanActivateFn = async (): Promise<boolean | import('@angular/router').UrlTree> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const apiAuthService = inject(ApiAuthService);

  try {
    if (!apiAuthService.isAuthenticated()) {
      const refreshToken = apiAuthService.getRefreshToken();
      if (refreshToken) {
        try {
          await firstValueFrom(apiAuthService.refreshToken());
        } catch {
          return true;
        }
      } else {
        return true;
      }
    }

    let profile = authService.profile();
    if (!profile) {
      const jwtUser = apiAuthService.getUser();
      if (jwtUser) {
        profile = apiAuthService.convertToUserProfile(jwtUser);
        authService.profile.set(profile);
      }
    }

    if (profile?.role && POS_ALLOWED_ROLES.has(profile.role)) {
      return router.createUrlTree(['/pos']);
    }

    return true;
  } catch {
    return true;
  }
};
